import { GetConsignmentItemFieldRequirementContext, toFieldRequirementResolverContext } from './types'
import getFieldRequirementP5 from './p5/fieldRequirementResolver'
import getFieldRequirementP6 from './p6/fieldRequirementResolver'
import { createGetFieldRequirementWithParentLookup } from '../../resolverFactory'
import { FieldRequirement } from '../../../../../models/fieldRules'

function getFieldRequirement(path: string, ctx: GetConsignmentItemFieldRequirementContext) {
  const fieldRequirementContext = toFieldRequirementResolverContext(path, ctx)

  return ctx.phase === 'p5' ? getFieldRequirementP5(path, fieldRequirementContext) : getFieldRequirementP6(path, fieldRequirementContext)
}

export const baseGetFieldRequirement = (
  path: string,
  ctx: GetConsignmentItemFieldRequirementContext,
): FieldRequirement => {
  const requirement = getFieldRequirement(path, ctx)
  if (!requirement) return 'optional'

  return requirement
}

export const getTransitConsignmentItemFormFieldRequirement = createGetFieldRequirementWithParentLookup(baseGetFieldRequirement)
